export default __webpack_public_path__ + "static/Agro-logo-colored-060c5ac3ad3ed36997abf76c69e612dc.svg";